import React from 'react'
import { Chip as BSChip, ChipProps as BSChipProps } from './Chip'
import { Chip as MUIChip, ChipProps as MUIChipProps } from './MUIChip'

export type ChipProps = BSChipProps | MUIChipProps
const birdsongVariants = ['general', 'success', 'warning', 'error']

export const Chip = (props: ChipProps) => {
  const { variant } = props

  if (!variant || birdsongVariants.includes(variant)) {
    return <BSChip {...(props as BSChipProps)} />
  }

  return <MUIChip {...(props as MUIChipProps)} />
}
